// assets
import { IconReport } from '@tabler/icons';
import rwdChild from './RwdChild';

// constant
const icons = { IconReport };

const rewardsCol = {
    id: `rewardsCol-${Math.random()}`,
    title: 'Rewards',
    type: 'collapse',
    // url: `/dashboard/default`,
    icon: icons.IconReport,
    breadcrumbs: false,
    children: rwdChild,
    role: process.env.REACT_APP_RL_RWDCOL
};

export default rewardsCol;
